const noop: () => void = () => undefined;

export default noop;
